var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_LOAD_STATE } from 'globals/enums';
import { GET_DEVICE_HEALTH, RESET_DEVICE_HEALTH, SET_DEVICE_HEALTH_DATA, SET_DEVICE_HEALTH_ERROR, SET_DEVICE_HEALTH_FILTER, SET_DEVICE_HEALTH_PAGE, SET_DEVICE_HEALTH_SEARCH_QUERY, } from './DeviceHealth.actions';
var initialState = {
    loadingStatus: API_LOAD_STATE.NOT_LOADED,
    data: [],
    currentPage: 1,
    pagination: {
        page: 1,
        page_size: 25,
        total: 0,
        total_pages: 0,
        has_next: false,
        has_previous: false,
    },
    searchQuery: '',
    activeFilter: 'needs-attention',
    summary: {},
    error: '',
};
var DeviceHealthReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_DEVICE_HEALTH:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.PROGRESS, data: [], error: '' });
        case SET_DEVICE_HEALTH_DATA:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.SUCCESSFUL, data: action.payload.data, pagination: (_a = action.payload.pagination) !== null && _a !== void 0 ? _a : state.pagination, summary: (_b = action.payload.summary) !== null && _b !== void 0 ? _b : state.summary });
        case SET_DEVICE_HEALTH_ERROR:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.ERROR, error: action.payload });
        case SET_DEVICE_HEALTH_PAGE:
            return __assign(__assign({}, state), { currentPage: action.payload });
        case SET_DEVICE_HEALTH_SEARCH_QUERY:
            return __assign(__assign({}, state), { searchQuery: action.payload, currentPage: 1 });
        case SET_DEVICE_HEALTH_FILTER:
            return __assign(__assign({}, state), { activeFilter: action.payload, currentPage: 1 });
        case RESET_DEVICE_HEALTH:
            return initialState;
        default:
            return state;
    }
};
export default DeviceHealthReducer;
